import type { DF_E577Response } from "@r3shared/types/datafinders/responses/DF_E577.types";
import type {
	ProtocoloPlanilhaCega
} from "@r3shared/types/WMS/conferenciaPlanilha/planilhaCega.types";

import type { E479Response, E581Response } from "@r3shared/types/WMS/MODU_COLETOR";
import type { E577_S581Response } from "@r3shared/types/WMS/MODU_COLETOR/E577";
import type { tipoLoteEntradaResponse } from "@r3shared/types/WMS/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR/conferencia.types";
import type { ProtocoloAcondicionamentoAntecipadoResponse } from "@r3shared/types/WMS/TMWS.types";


export const useConferenciaPlanilhaCegaStore = defineStore(
	"conferenciaPlanilhaCegaStore",
	() => {
		const protocolo = ref<ProtocoloPlanilhaCega | null>(null);
		function setProtocolo(value: ProtocoloPlanilhaCega | null) {
			protocolo.value = value;
		}

		const recebimentoChamadoRotinaB315 = ref<boolean>(false);

		function setRecebimentoChamadoRotinaB315(value: boolean) {
			recebimentoChamadoRotinaB315.value = value;
		}

		const itensConferidos = ref<E581Response[]>([]);

		function setItensConferidos(value: E581Response[]) {
			itensConferidos.value = value;
		}

		/** Itens ainda não conferidos no protocolo (aba Pendentes / E577_S581) */
		const itensPendentes = ref<E577_S581Response[]>([]);

		function setItensPendentes(value: E577_S581Response[]) {
			itensPendentes.value = value;
		}

		const itemAtualEmConferencia = ref<(E581Response & E479Response) | null>(null);
		function atualizarItemAtualEmConferencia(newValue: E581Response & E479Response) {
			if (itemAtualEmConferencia.value) {
				itemAtualEmConferencia.value = { ...itemAtualEmConferencia.value, ...newValue };
			} else {
				itemAtualEmConferencia.value = newValue;
			}
		}

		// const mercadoriaSelecionada = ref<DF_E577Response>({} as DF_E577Response);
		const mercadoriaSelecionada = ref<DF_E577Response | null>(null);
		function setMercadoriaSelecionada(value: DF_E577Response) {
			mercadoriaSelecionada.value = value;
		}

		// -------------------------------------------------------------------------
		// Tara
		const taraPalete = ref(0);
		const inputTaraPaleteEnabled = ref<boolean>(false);

		function setTaraPalete(value: number) {
			taraPalete.value = value;
		}

		const taraCaixa = ref(0);
		const inputTaraCaixaEnabled = ref<boolean>(false);

		function setTaraCaixa(value: number) {
			taraCaixa.value = value;
		}

		const taraUnidade = ref(0);
		const inputTaraUnidadeEnabled = ref<boolean>(false);

		function setTaraUnidade(value: number) {
			taraUnidade.value = value;
		}

		const labelTaraUnidadeFieldset = ref<string>("Unidade - Peso em kg");
		const qtdTaraPalete = ref<number>(0);
		const qtdTaraCaixa = ref<number>(0);
		const qtdTaraUnidade = ref<number>(0);

		function setLabelTaraUnidadeFieldset(value: string) {
			labelTaraUnidadeFieldset.value = value;
		}

		// tara unidade 
		const qtdTaraUnidadeEnabled = ref<boolean>(false);
		function setQtdTaraUnidadeEnabled(value: boolean) {
			qtdTaraUnidadeEnabled.value = value;
		}

		// tara caixa
		const qtdTaraCaixaEnabled = ref<boolean>(false);
		function setQtdTaraCaixaEnabled(value: boolean) {
			qtdTaraCaixaEnabled.value = value;
		}

		// tara palete
		const qtdTaraPaleteEnabled = ref<boolean>(false);
		function setQtdTaraPaleteEnabled(value: boolean) {
			qtdTaraPaleteEnabled.value = value;
		}

		//--------------------------------------------------------------------------
		// Recebimento

		const mercadoriaConferida = ref<DF_E577Response | null>(null);





		// Acondicionamento antecipado
		const acondicionamentoAntecipadoLabel = ref("Tipo de armazenamento");
		const btnConferirRecebimento = ref(true);
		const acondicionamentoAntecipado = ref<ProtocoloAcondicionamentoAntecipadoResponse | null>(null);

		// Picking Acondicionado 
		const pickingAcondicionadoValue = ref<"S" | "N" | null>(null);
		const pickingAcondicionadoEnabled = ref<boolean>(true);
		const pickingAcondicionadoLabel = ref<string>("Acond Pick");

		function setPickingAcondicionadoValue(value: "S" | "N" | null) {
			pickingAcondicionadoValue.value = value;
		}

		function setPickingAcondicionadoEnabled(enabled: boolean) {
			pickingAcondicionadoEnabled.value = enabled;
		}

		function setPickingAcondicionadoLabel(label: string) {
			pickingAcondicionadoLabel.value = label;
		}

		// Botão LxC (Lastro x Camada)
		const botaoLxCVisible = ref<boolean>(true);
		const botaoLxCLabel = ref<string>("LxC");
		const botaoLxCEnabled = ref<boolean>(true);

		function setBotaoLxCVisible(visible: boolean) {
			botaoLxCVisible.value = visible;
		}

		function setBotaoLxCEnabled(enabled: boolean) {
			botaoLxCEnabled.value = enabled;
		}

		function setBotaoLxCLabel(label: string) {
			botaoLxCLabel.value = label;
		}

		// Campo altura
		const alturaFieldValue = ref<number | null>(null);
		const alturaFieldEnabled = ref<boolean>(true);
		const alturaFieldLabel = ref<string>("Altura (cm)");

		function setAlturaFieldValue(value: number | null) {
			alturaFieldValue.value = value;
		}

		function setAlturaFieldEnabled(enabled: boolean) {
			alturaFieldEnabled.value = enabled;
		}

		function setAlturaFieldLabel(label: string) {
			alturaFieldLabel.value = label;
		}


		function setAcondicionamentoAntecipado(value: ProtocoloAcondicionamentoAntecipadoResponse | null) {
			acondicionamentoAntecipado.value = value;
			// Delphi: LabelAcondAntecip.Visible := True e Caption := tipo ("3-Antecipa Palete…").
			// Só esconde quando não há tipo no protocolo.
			const rotulo = value?.tipoAntecipacao?.trim() ?? "";
			if (value && rotulo !== "") {
				acondicionamentoAntecipadoLabel.value = rotulo;
				btnConferirRecebimento.value = true;
			} else {
				acondicionamentoAntecipadoLabel.value = "Tipo de armazenamento";
				btnConferirRecebimento.value = false;
			}
		}

		const btnLastroCamadaVisible = ref(true);

		function setBtnLastroCamadaVisible(value: boolean) {
			btnLastroCamadaVisible.value = value;
		}

		const panelSemiAutomaticoVisible = ref(false);
		function setPanelSemiAutomaticoVisible(value: boolean) {
			panelSemiAutomaticoVisible.value = value;
		}

		// cabeçalho de nota de entrada
		const tipoLoteEntrada = ref<tipoLoteEntradaResponse["TIPO_LT_444"]>();

		function setTipoLoteEntrada(value: tipoLoteEntradaResponse["TIPO_LT_444"]) {
			tipoLoteEntrada.value = value;
		}


		const fornecedorLote = ref<tipoLoteEntradaResponse["ID_EMISSOR_444"]>();
		function setFornecedorLote(value: tipoLoteEntradaResponse["ID_EMISSOR_444"]) {
			fornecedorLote.value = value;
		}

		/**
		 * Impressora direcionada (Delphi ComboBoxImpressoras / ts_Impressora).
		 * Prioridade sobre o cadastro padrão na impressão do acondicionamento antecipado.
		 */
		const impressoraDirecionada = ref<string>("");
		function setImpressoraDirecionada(value: string) {
			impressoraDirecionada.value = (value ?? "").trim();
		}
		const impressorasDisponiveis = ref<string[]>([]);
		function adicionarImpressoraDisponivel(nome: string) {
			const n = (nome ?? "").trim();
			if (!n) return;
			if (!impressorasDisponiveis.value.includes(n)) {
				impressorasDisponiveis.value = [...impressorasDisponiveis.value, n];
			}
		}





		// -------------------------------------------------------------------------
		return {
			protocolo,
			setProtocolo,
			recebimentoChamadoRotinaB315,
			setRecebimentoChamadoRotinaB315,
			itensConferidos,
			setItensConferidos,
			itensPendentes,
			setItensPendentes,
			itemAtualEmConferencia,
			atualizarItemAtualEmConferencia,
			mercadoriaSelecionada,
			setMercadoriaSelecionada,

			taraPalete,
			inputTaraPaleteEnabled,
			setTaraPalete,
			taraCaixa,
			inputTaraCaixaEnabled,
			setTaraCaixa,
			taraUnidade,
			inputTaraUnidadeEnabled,
			setTaraUnidade,
			labelTaraUnidadeFieldset,
			setLabelTaraUnidadeFieldset,
			qtdTaraPalete,
			qtdTaraCaixa,
			qtdTaraUnidade,
			qtdTaraUnidadeEnabled,
			setQtdTaraUnidadeEnabled,
			qtdTaraCaixaEnabled,
			setQtdTaraCaixaEnabled,
			qtdTaraPaleteEnabled,
			setQtdTaraPaleteEnabled,
			acondicionamentoAntecipadoLabel,
			btnConferirRecebimento,
			acondicionamentoAntecipado,
			setAcondicionamentoAntecipado,
			pickingAcondicionadoValue,
			pickingAcondicionadoEnabled,
			pickingAcondicionadoLabel,
			setPickingAcondicionadoValue,
			setPickingAcondicionadoEnabled,
			setPickingAcondicionadoLabel,
			btnLastroCamadaVisible,
			setBtnLastroCamadaVisible,
			panelSemiAutomaticoVisible,
			setPanelSemiAutomaticoVisible,
			tipoLoteEntrada,
			setTipoLoteEntrada,
			fornecedorLote,
			setFornecedorLote,
			botaoLxCVisible,
			botaoLxCLabel,
			botaoLxCEnabled,
			setBotaoLxCVisible,
			setBotaoLxCEnabled,
			setBotaoLxCLabel,
			alturaFieldValue,
			alturaFieldEnabled,
			alturaFieldLabel,
			setAlturaFieldValue,
			setAlturaFieldEnabled,
			setAlturaFieldLabel,
			mercadoriaConferida,
			impressoraDirecionada,
			setImpressoraDirecionada,
			impressorasDisponiveis,
			adicionarImpressoraDisponivel,
		}
	}
)